<template>
  <div>
    <v-card style="margin: 80px auto;width: 500px;">
      <v-container style="margin-top:64px;">
        <v-row class="row">
          <v-col cols="4" class="fld">
            <span class="flds">姓名</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="name" dense solo></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="4" class="fld">
            <span class="flds">当前密码</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="pwd" type="password" dense solo></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="4" class="fld">
            <span class="flds">密码</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="pwd1" type="password" dense solo></v-text-field>
          </v-col>
        </v-row>
        <v-row class="row">
          <v-col cols="4" class="fld">
            <span class="flds">密码(再输一次)</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="pwd2" type="password" dense solo></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4"></v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="save">确定</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<style>

</style>

<script>
import { setUser } from '@/api/user'
import { Msg, MsgError } from '@/libs/util';

export default {
  data: () => ({
    name: '',
    pwd: '',
    pwd1: '',
    pwd2: ''
  }),
  methods: {
    save () {
      if (this.pwd1 !== this.pwd2) {
        MsgError('两次输入密码不一样')
        return
      }
      setUser(this.$store.state.user.userId, this.name, this.pwd, this.pwd1).then(res => {
        Msg('修改成功')
        this.$store.state.user.userName = this.name
      }).catch((err) => {
        MsgError("error" + err);
      })
    }
  },
  mounted () {
    this.name = this.$store.state.user.userName
  }
}
</script>
